import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type {
  Journey,
  JourneyRequest,
  JourneyVerifyRequest,
} from '../../domain/models/journey'
import type { IJourney } from '../../domain/use-cases/i-journey'
import type { IJourneyClient } from '../data-sources/i-journey-client'

export class JourneyRepository implements IJourney {
  constructor(private readonly dataSource: IJourneyClient) {}

  async getJourney(params: JourneyVerifyRequest): Promise<Journey | null> {
    const result = await this.dataSource.getJourney(params)

    if (result.status === HttpStatusCode.NOT_FOUND) {
      return null
    }

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return result.data
  }

  async createJourney(params: JourneyRequest): Promise<Journey> {
    const result = await this.dataSource.createJourney(params)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return result.data
  }

  async concludeJourney(journeyId: number): Promise<boolean> {
    const result = await this.dataSource.concludeJourney(journeyId)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return true
  }
}
